<template>
  <div class="sidebar">
    <el-scrollbar wrap-class="scrollbar-wrapper" class="scroll">
      <logo :collapse="isCollapse"></logo>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        ></sidebar-item>
      </el-menu>
    </el-scrollbar>
    <Footer :collapse="isCollapse"></Footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import Logo from "./Logo";
import Footer from "./Footer";
import variables from "../../../styles/variables.scss";
// import Cookies from "js-cookie";
export default {
  components: { SidebarItem, Logo, Footer },
  computed: {
    ...mapGetters(["sidebar"]),
    routes() {
      return this.$router.options.routes;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
  // watch: {
  //   isCollapse() {
  //     var sidebarStatus = !JSON.parse(Cookies.get("sidebarStatus"));
  //     return sidebarStatus;
  //   }
  // },
  // data() {
  //   return {
  //     isCollapse: !JSON.parse(Cookies.get("sidebarStatus"))
  //   };
  // }
};
</script>
<style lang="scss" scoped>
.sidebar {
  text-align: left;
  .scroll {
    min-height: calc(100vh -70px);
  }
  .footer-logo-container {
    // margin-top: -13vh;
    position: absolute;
    bottom: 1vh;
  }
}
</style>
